<template>
  <div class="brands-list">
    <component
      :is="image.name"
      v-for="(image, index) in images"
      :key="index"
      :width="`${isMobile ? image.mobileSize[0] : image.size[0]}`"
      :height="`${isMobile ? image.mobileSize[1] : image.size[1]}`"
    />
  </div>
</template>

<script>
import Neurons from '~/components/Common/Svg/Brands/Neurons';
import Electrolux from '~/components/Common/Svg/Brands/Electrolux';
import EA from '~/components/Common/Svg/Brands/Ea';
import Winamp from '~/components/Common/Svg/Brands/Winamp';
import isMobile from '~/mixins/responsive';

export default {
  name: 'Brands',
  components: {
    Neurons,
    Electrolux,
    EA,
    Winamp,
  },
  mixins: [isMobile],
  data() {
    return {
      images: [
        { name: 'Neurons', size: [110, 40], mobileSize: [97, 35] },
        { name: 'Electrolux', size: [152, 35], mobileSize: [134, 30] },
        { name: 'EA', size: [48, 47], mobileSize: [39, 38] },
        { name: 'Winamp', size: [127, 40], mobileSize: [108, 34] },
      ],
    };
  },
};
</script>

<style lang="scss">
@import './Brands.scss';
</style>
